import styled from 'styled-components';

export const TabContentInner = styled.div`
  border-top: 1px solid #e1e7ee;
  padding: 2em;
  width: 100%;
  color: black;
`;

export const TriptypeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1rem 0;
`;

export const BusinessForm = styled.section`
  border-top: 1px solid #e1e7ee;
  padding: 2em
`
export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 1.5rem;
`

export const FormInputWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-right: 1rem;
  label {
    font-size: 1.4rem;
    color: #141823;
    padding-bottom: 1rem;
  }
  input {
    border: 1px solid #e5edf6;
    border-radius: 0.4rem;
    padding: 1rem;
    width: 100%;
    font-size: 1.4rem;
    height: 3.5rem;
    background: white;
    outline: 0;
    &.error {
      border: 1px solid #ff3a5c;
    }
  }
`;
export const Error = styled.p`
  font-size: 1.2rem;
  color: #ff3a5c;
  padding-top: 0.5rem;
`;
